import React from 'react';
import { useLanguage } from '../utils/i18n';
import { motion } from 'framer-motion';
import { glassStyles } from '../utils/glassStyles';

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();

  const inactiveButtonStyle = {
    // Define a subtle style for the inactive button
    // Example: Slight transparency, no strong border/blur
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    transition: 'all 0.3s ease-in-out'
  };

  const activeButtonStyle = glassStyles.button;

  return (
    <div className="flex items-center space-x-2">
      {/* Spanish Button */}
      <motion.button
        onClick={() => changeLanguage('es')}
        className="px-3 py-1 rounded-full text-sm font-medium text-white focus:outline-none"
        style={language.code === 'es' ? activeButtonStyle : inactiveButtonStyle}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        ES
      </motion.button>

      {/* English Button */}
      <motion.button
        onClick={() => changeLanguage('en')}
        className="px-3 py-1 rounded-full text-sm font-medium text-white focus:outline-none"
        style={language.code === 'en' ? activeButtonStyle : inactiveButtonStyle}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        EN
      </motion.button>
    </div>
  );
};

export default LanguageSwitcher;
